export class Category {
	id?: number;
	name?: string;

	constructor(init?: Partial<Category>) {
		Object.assign(this, init);
	}
}
